/*
 * @Description:
 * @Autor: Chen
 * @Date: 2020-01-21 14:29:03
 * @LastEditors: chen
 * @LastEditTime: 2020-05-12 17:24:04
 */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth-interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];
